<script setup>
  import { ref } from "vue";
  import { Label } from "@/components/ui/label";
  import { Button } from "@/components/ui/button";
  import { RadioGroup, RadioGroupItemIcon } from "@/components/ui/radio-group";
  import { MousePointerClick } from "lucide-vue-next";
  import AiStar from "@/components/episto-ui/ai/AiStar.vue";
  import ReportEmptyStateAi from "./ReportEmptyStateAi.vue";
  import ReportEmptyStateManual from "./ReportEmptyStateManual.vue";

  const emit = defineEmits(["generate"]);

  const startMode = ref(null);
  const aiStateRef = ref(null);
</script>

<template>
  <div class="h-full flex flex-col">
    <div class="flex-1 overflow-y-auto py-8">
      <div class="w-full max-w-2xl mx-auto px-6">
        <p class="text-sm font-bold">It's time to start building your report.</p>

        <!-- Creation mode -->
        <Label class="mt-6 mb-2 block">Select a creation mode</Label>
        <RadioGroup
          v-model="startMode"
          class="grid grid-cols-2 gap-3">
          <RadioGroupItemIcon
            value="ai"
            label="AI-assisted"
            description="Let AI create a report from your instructions"
            class="h-full">
            <template #icon>
              <AiStar />
            </template>
          </RadioGroupItemIcon>
          <RadioGroupItemIcon
            value="manual"
            label="Manual"
            description="Build your report slide by slide"
            class="h-full">
            <template #icon>
              <MousePointerClick />
            </template>
          </RadioGroupItemIcon>
        </RadioGroup>

        <ReportEmptyStateAi
          v-if="startMode === 'ai'"
          ref="aiStateRef"
          @generate="emit('generate', $event)" />

        <ReportEmptyStateManual
          v-else-if="startMode === 'manual'"
          class="mt-6" />
      </div>
    </div>

    <!-- Sticky generate button (outside scroll area) -->
    <div
      v-if="startMode === 'ai' && aiStateRef?.activePreset"
      class="flex-shrink-0 border-t bg-background px-6 py-3">
      <div class="flex justify-center">
        <Button
          size="lg"
          @click="aiStateRef?.handleGenerate()">
          <AiStar class="w-4 h-4 mr-2" />
          Generate with AI
        </Button>
      </div>
    </div>
  </div>
</template>
